import { createMuiStyles } from '../../utils/mui';
export const snackbarStackStyles = createMuiStyles({
  stack: {
    width: 'auto',
    position: 'fixed',
    mr: {
      xs: 1,
      md: 3,
    },
    bottom: {
      xs: '0.5rem',
      md: '1.5rem',
    },
    left: {
      xs: '0.5rem',
      md: '1.5rem',
    },
    zIndex: 'tooltip',
  },
  stackItem: {
    position: 'static',
  },
});
